"use client"

import { View, StyleSheet } from "react-native"
import { Text, useTheme } from "react-native-paper"
import { NodeSummaryContent } from "../NodeSummary/NodeSummaryContent"
import type { TabComponentProps } from "../../types/tabs"

export function NodeSummaryTab({ selectedNode }: TabComponentProps) {
    const theme = useTheme()

    if (!selectedNode) {
        return (
            <View style={[styles.empty, { backgroundColor: theme.colors.elevation.level1 }]}>
                <Text style={{ color: theme.colors.onSurfaceVariant }}>Select a node to view its summary</Text>
            </View>
        )
    }

    return (
        <View style={[styles.container, { backgroundColor: theme.colors.elevation.level1 }]}>
            <NodeSummaryContent node={selectedNode} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        height: "100%",
    },
    empty: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
    },
})
